module.exports = __webpack_public_path__ + "img/title4.342448ec.png";